import React, { Suspense, useEffect, useState } from "react";

// import dynamic from "next/dynamic";


const LazyLottie = React.lazy(() => import("./LazyLottie"));

// const LazyLottie = () => <p>Loading</p>


function QLottie({ styles }) {


    return <Suspense fallback={<p>Loading...</p>}>
        <LazyLottie styles={styles} />
    </Suspense>
}

export default QLottie;